import React, { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import { getMarketingT } from '../utils/marketingTranslations';
import MarketingLayout from '../components/marketing/MarketingLayout';

function ContactPage() {
  const { language } = useApp();
  const mt = getMarketingT(language);
  const isRTL = language === 'ar';
  const [form, setForm] = useState({ name: '', restaurant: '', phone: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const handleChange = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const handleWhatsApp = () => {
    const text = encodeURIComponent(
      `👋 Hi! I'm interested in Wamenu.\n\n📋 Name: ${form.name || '—'}\n🏪 Restaurant: ${form.restaurant || '—'}\n📞 Phone: ${form.phone || '—'}\n💬 Message: ${form.message || '—'}`
    );
    window.open(`https://wa.me/+212722779197?text=${text}`, '_blank');
    setSubmitted(true);
  };

  const handleEmail = () => {
    const subject = encodeURIComponent(`Wamenu Inquiry — ${form.restaurant || 'New Restaurant'}`);
    const body = encodeURIComponent(`Hi Wamenu team,\n\nName: ${form.name}\nRestaurant: ${form.restaurant}\nPhone: ${form.phone}\n\n${form.message}\n\nLooking forward to hearing from you!`);
    window.open(`mailto:todart20azur02@gmail.com?subject=${subject}&body=${body}`, '_blank');
  };

  const inputStyle = {
    width: '100%', padding: '14px 16px',
    border: '1.5px solid var(--border)', borderRadius: 'var(--radius-sm)',
    fontSize: 15, fontFamily: isRTL ? 'var(--font-arabic)' : 'var(--font-body)',
    color: 'var(--text-primary)', background: 'var(--bg-primary)',
    transition: 'all 0.2s', outline: 'none', boxSizing: 'border-box',
  };

  return (
    <MarketingLayout>
      <style>{`
        @keyframes mk-fadeUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .mk-contact-hero {
          padding: 140px 24px 60px; text-align: center;
          background: var(--bg-secondary);
          border-bottom: 1px solid var(--border-light);
        }
        .mk-form-card {
          padding: 40px; border-radius: var(--radius-lg);
          background: var(--bg-secondary); border: 1px solid var(--border-light);
          box-shadow: var(--shadow-sm);
        }
        .mk-form-input:focus {
          border-color: var(--accent) !important;
          box-shadow: 0 0 0 3px var(--accent-light) !important;
          background: var(--bg-secondary) !important;
        }
        .mk-wa-btn {
          width: 100%; padding: 16px; background: #25D366; color: #fff;
          border: none; border-radius: var(--radius-md);
          font-size: 16px; font-weight: 600; cursor: pointer;
          transition: all 0.3s; font-family: inherit;
          display: flex; align-items: center; justify-content: center; gap: 10px;
        }
        .mk-wa-btn:hover { background: #1EBE5A; transform: translateY(-2px); }
        .mk-email-btn {
          width: 100%; padding: 14px;
          background: transparent; color: var(--text-secondary);
          border: 1.5px solid var(--border); border-radius: var(--radius-md);
          font-size: 15px; font-weight: 500; cursor: pointer;
          transition: all 0.2s; font-family: inherit;
        }
        .mk-email-btn:hover { border-color: var(--text-primary); color: var(--text-primary); }
        .mk-info-card {
          padding: 28px; border-radius: var(--radius-md);
          background: var(--bg-secondary); border: 1px solid var(--border-light);
          display: flex; gap: 16px; align-items: flex-start;
          transition: all 0.3s;
        }
        .mk-info-card:hover { transform: translateY(-2px); box-shadow: var(--shadow-md); }
        .mk-info-icon {
          width: 48px; height: 48px; border-radius: var(--radius-md);
          display: flex; align-items: center; justify-content: center;
          font-size: 22px; flex-shrink: 0;
          background: var(--accent-light);
        }
        .mk-success-card {
          padding: 48px; border-radius: var(--radius-lg);
          background: var(--bg-secondary); border: 1px solid var(--border-light);
          text-align: center;
        }
        @media (max-width: 768px) {
          .mk-contact-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
          .mk-form-card { padding: 24px !important; }
        }
      `}</style>

      {/* Hero */}
      <section className="mk-contact-hero">
        <p style={{ fontSize: 13, fontWeight: 600, color: 'var(--accent)', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 16, animation: 'mk-fadeUp 0.6s ease both' }}>
          {mt('contact_label')}
        </p>
        <h1 style={{
          fontFamily: isRTL ? 'var(--font-arabic)' : 'var(--font-display)',
          fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: 700,
          color: 'var(--text-primary)', letterSpacing: isRTL ? '0' : '-0.03em',
          marginBottom: 20, animation: 'mk-fadeUp 0.6s ease 0.1s both',
        }}>
          {mt('contact_title')}
        </h1>
        <p style={{ fontSize: 18, color: 'var(--text-muted)', lineHeight: 1.7, maxWidth: 480, margin: '0 auto', animation: 'mk-fadeUp 0.6s ease 0.2s both' }}>
          {mt('contact_sub')}
        </p>
      </section>

      {/* Contact */}
      <section style={{ padding: '60px 24px 100px' }}>
        <div className="mk-contact-grid" style={{
          display: 'grid', gridTemplateColumns: '1fr 1fr',
          gap: 48, maxWidth: 1000, margin: '0 auto',
        }}>
          {/* Form */}
          <div>
            {submitted ? (
              <div className="mk-success-card">
                <div style={{ fontSize: 48, marginBottom: 16 }}>🎉</div>
                <h3 style={{ fontSize: 22, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 8 }}>
                  {mt('contact_success_title')}
                </h3>
                <p style={{ fontSize: 15, color: 'var(--text-muted)', lineHeight: 1.7, marginBottom: 24 }}>
                  {mt('contact_success_desc')}
                </p>
                <button onClick={() => setSubmitted(false)} style={{
                  padding: '12px 28px', background: 'var(--bg-tertiary)',
                  border: 'none', borderRadius: 'var(--radius-sm)',
                  fontSize: 14, fontWeight: 600, cursor: 'pointer',
                  color: 'var(--text-primary)', fontFamily: 'inherit',
                }}>
                  {mt('contact_send_another')}
                </button>
              </div>
            ) : (
              <div className="mk-form-card">
                {[
                  { key: 'name', label: mt('contact_name'), ph: mt('contact_name_ph') },
                  { key: 'restaurant', label: mt('contact_restaurant'), ph: mt('contact_restaurant_ph') },
                  { key: 'phone', label: mt('contact_phone'), ph: mt('contact_phone_ph') },
                ].map(field => (
                  <div key={field.key} style={{ marginBottom: 20 }}>
                    <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 8, letterSpacing: '0.02em' }}>
                      {field.label}
                    </label>
                    <input
                      className="mk-form-input"
                      style={inputStyle}
                      placeholder={field.ph}
                      value={form[field.key]}
                      onChange={handleChange(field.key)}
                    />
                  </div>
                ))}
                <div style={{ marginBottom: 20 }}>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 8 }}>
                    {mt('contact_message')}
                  </label>
                  <textarea
                    className="mk-form-input"
                    style={{ ...inputStyle, resize: 'vertical', minHeight: 120 }}
                    placeholder={mt('contact_message_ph')}
                    value={form.message}
                    onChange={handleChange('message')}
                  />
                </div>
                <button className="mk-wa-btn" onClick={handleWhatsApp}>
                  <span>💬</span> {mt('contact_send_wa')}
                </button>
                <div style={{ textAlign: 'center', padding: '12px 0', color: 'var(--text-muted)', fontSize: 13 }}>
                  {mt('contact_or')}
                </div>
                <button className="mk-email-btn" onClick={handleEmail}>
                  📧 {mt('contact_send_email')}
                </button>
              </div>
            )}
          </div>

          {/* Info */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {[
              { icon: '💬', title: mt('contact_wa_label'), desc: mt('contact_wa_desc'), link: 'https://wa.me/+212722779197', linkText: '+212 722 779 197 →' },
              { icon: '📧', title: mt('contact_email_label'), desc: mt('contact_email_desc'), link: 'mailto:todart20azur02@gmail.com', linkText: 'todart20azur02@gmail.com →' },
              { icon: '📍', title: mt('contact_location_label'), desc: mt('contact_location_desc') },
              { icon: '⏱️', title: mt('contact_response_label'), desc: mt('contact_response_desc') },
            ].map((item, i) => (
              <div key={i} className="mk-info-card">
                <div className="mk-info-icon">{item.icon}</div>
                <div>
                  <h4 style={{ fontSize: 16, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 4, fontFamily: isRTL ? 'var(--font-arabic)' : 'var(--font-body)' }}>
                    {item.title}
                  </h4>
                  <p style={{ fontSize: 14, color: 'var(--text-muted)', lineHeight: 1.6 }}>{item.desc}</p>
                  {item.link && (
                    <a href={item.link} target="_blank" rel="noreferrer" style={{
                      fontSize: 14, color: 'var(--accent)', fontWeight: 600,
                      textDecoration: 'none', marginTop: 4, display: 'inline-block',
                    }}>
                      {item.linkText}
                    </a>
                  )}
                </div>
              </div>
            ))}

            {/* Trust badge */}
            <div style={{
              padding: 24, borderRadius: 'var(--radius-md)',
              background: 'var(--bg-tertiary)', border: '1px solid var(--border-light)',
              textAlign: 'center',
            }}>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 8 }}>{mt('contact_trusted_by')}</div>
              <div style={{
                fontFamily: isRTL ? 'var(--font-arabic)' : 'var(--font-display)',
                fontSize: 28, fontWeight: 700, color: 'var(--accent)',
              }}>
                50+ {mt('hero_restaurants')}
              </div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 4 }}>{mt('contact_across')}</div>
            </div>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}

export default ContactPage;